import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { IconButton } from 'react-toolbox/lib/button';
import { Dialog } from 'react-toolbox';
import TextArea from 'components/TextArea';
import ColoredButton from 'components/ColoredButton';
import RadioButtons from 'components/RadioButtons';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import modalStyles from 'modal.scss';

const BUTTONS = [{
  label: 'Yes, I certify that a permit or other documentation is required',
  value: 'yes',
}, {
  label: 'No, I certify that a permit or other documentation is NOT required',
  value: 'no',
}];

export default class SubmitDocumentsModal extends Resetter(Validator(React.Component)) {
  static DEFAULT_STATE = { workOrderExplanation: '', isDocumentRequired: '' }

  handleSubmit = () => {
    const { workOrderExplanation, isDocumentRequired } = this.state;
    const { phase, task: { slug }, updatePhaseTask } = this.props;
    updatePhaseTask(phase.id, slug, {
      task: { status: 'complete' },
      data: {
        workorder_explanation: workOrderExplanation, document_required: isDocumentRequired,
      },
    }).then(() => this.handleClose())
      .catch(() => {});
  }

  handleWorkOrderExplanation = e => this.setState({ workOrderExplanation: e.target.value });

  handleIsDocumentRequired = value => this.setState({ isDocumentRequired: value });

  missingFieldsMessage = () => {
    const { workOrderExplanation, isDocumentRequired } = this.state;
    let message = '';
    if (!workOrderExplanation) message = 'Explanation Needed';
    if (!isDocumentRequired) {
      const docRequired = 'Confirm Documentation Required';
      message = message ? message.concat(', ', docRequired) : docRequired;
    }
    return message;
  }

  render = () => {
    const { active, task } = this.props;
    const { workOrderExplanation, isDocumentRequired } = this.state;
    const submitDisabled = !workOrderExplanation || !isDocumentRequired;
    return (<Dialog
      active={active}
      className={modalStyles.modal}
      type="fullscreen"
      onEscKeyDown={this.handleClose}
      onOverlayClick={this.handleClose}
    >
      <IconButton
        icon="close"
        className={modalStyles.close}
        onClick={this.handleClose}
        tabIndex={-1}
      />
      <h5 className={modalStyles.title}>Complete Task: {task.name}</h5>
      <TextArea
        label="Please explain the actions taken or support needed to resolve the Work Order"
        value={workOrderExplanation}
        onChange={this.handleWorkOrderExplanation}
        autoFocus
      />
      <br />
      <p>Is a permit or other documentation required for this Work Order?</p>
      <RadioButtons
        onChange={this.handleIsDocumentRequired}
        selectedValue={isDocumentRequired}
        radioButtons={BUTTONS}
        text="Examples of applicable documentation include permits, permit extensions, passed inspections, engineered drawings, customer punch lists, etc."
      />
      <div className={modalStyles.actions}>
        {submitDisabled && <p className={modalStyles.missingFieldsMessage}>
          {this.missingFieldsMessage()}</p>}
        <ColoredButton
          color="green"
          responsive
          label="Complete Task"
          className={modalStyles.button}
          onClick={this.handleSubmit}
          disabled={submitDisabled}
        />
        <ColoredButton
          color="darkGray"
          responsive
          label="Cancel"
          className={modalStyles.button}
          onClick={this.handleClose}
        />
      </div>
    </Dialog>);
  }
}

SubmitDocumentsModal.propTypes = {
  active: PropTypes.bool.isRequired,
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  onClose: PropTypes.func.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
};

SubmitDocumentsModal.defaultProps = { active: false };



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/SubmitDocumentsModal/index.jsx